import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { saveAs } from "file-saver";
import { Observable } from 'rxjs';
import * as _ from 'lodash';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { config } from '../config';

@Injectable({
  providedIn: 'root'
})
export class DownloadService {

  constructor(private http: HttpClient) { }


  downloadCSV(data) {

    return new Observable<any>((observer) => {
      console.log("Observable");
      var that = this;
      this.http.post(config.baseApiUrl + "document/download-csv", data).subscribe((res: any) => {

        observer.next(res);
        // observer.complete();
      }, err => {
        console.log("ERROR ")
        observer.error(err);
      },
        () => {
          console.log("CALL COMPLETED ")
          observer.complete();
        })
    });

  }


  downloadAttendance2(unitList, attendanceList, currentJob) {
    return new Observable<any>((observer) => {
      // this.loading = true
      console.log("attendance data when click on download2", currentJob);
      let attendanceData = attendanceList.attendance

      let instructors = []
      currentJob.instructors.forEach(item => {
        instructors.push(item.name)
      })
      let clients = []
      currentJob.clients.forEach(item => {
        clients.push(item.name)
      })
      let finalJsonArray = []
      let tempArray = []

      let jobHeaders = ['Job Title', 'Course Title', 'Course Duration', 'Client Name', 'Client Location', 'Instructors', 'Days', 'First Date', 'Last Date']
      let jobData = [currentJob.title, currentJob.course.title, currentJob.course.duration, currentJob.clients[0].client.name, currentJob.clients[0].location.title, instructors.join(' '), currentJob.totalDays.join(' ')]

      if (currentJob.scheduleDates && currentJob.scheduleDates == true) {
        jobData.push(moment(new Date(currentJob.startingDate).toUTCString().replace(',', "")).format("DD/MM/YYYY"), moment(new Date(currentJob.endingDate).toUTCString().replace(',', "")).format("DD/MM/YYYY"))
      } else {
        jobData.push(moment(new Date(currentJob.singleJobDate[0]).toUTCString().replace(',', "")).format("DD/MM/YYYY"), moment(new Date(currentJob.singleJobDate[currentJob.singleJobDate.length - 1]).toUTCString().replace(',', "")).format("DD/MM/YYYY"))
      }
      console.log("jobDatal")
      tempArray.push(jobHeaders, ['\r'], jobData, ['\r'], ['\r'], ['\r'])





      let duration = currentJob.course.courseMetaId.jobDatesList.length
      console.log("here is duration ==>", duration)
      let headers = ['Name']
      let headers1 = ['Days/Date']
      let headers2 = ['UnitList']
      for (let i = 0; i < duration; i++) {
        let dateformate = new Date(currentJob.course.courseMetaId.jobDatesList[i].date)

        /**selected course Unit Value get */

        let tempCourseDetails
        let tempHeaders

        tempCourseDetails = unitList.filter(function (o) {
          return currentJob.course.courseMetaId.jobDatesList[i].courseDetails.some(selectedUnit => selectedUnit == o._id)
        })

        tempHeaders = tempCourseDetails.map(function (value) {
          return value.title;
        });
        /**** */

        console.log("Helllo here is the tempcourse details Array selected date", tempHeaders.join(','))


        headers1.push(((dateformate.getDate() > 9) ? dateformate.getDate() : ('0' + dateformate.getDate())) + '/' + ((dateformate.getMonth() > 8) ? (dateformate.getMonth() + 1) : ('0' + (dateformate.getMonth() + 1))) + '/' + dateformate.getFullYear() + "(Day- " + currentJob.course.courseMetaId.jobDatesList[i].day + ")")
        // headers1.push("")
        // headers1.push("")

        headers2.push("\"" + tempHeaders.join(',') + "\"")
        // headers2.push("")
        // headers2.push("")


        headers.push("Day-" + String(i + 1) + "(AM)")
        headers.push("Day-" + String(i + 1) + "(PM)")
        // headers.push("Day-" + String(i + 1) + "Time")
      }
      tempArray.push(headers1, ['\r'])
      tempArray.push(headers2, ['\r'], ['\r'], ['\r'], ['\r'])
      tempArray.push(headers)






      console.log("total attendacne list", attendanceList);


      attendanceList.forEach(item => {
        console.log("item----====>", item);
        let temp = {}
        let array = []
        temp['Name'] = item.name
        temp['_id'] = item._id
        finalJsonArray.push(temp)
        array.push(item.name)
        for (let i = 0; i < duration; i++) {
          let index = _.findIndex(finalJsonArray, function (o) { return o._id == item._id })



          if (index > -1) {
            let amStatus;
            let pmStatus;
            let attendanceAmHours;
            let attendancePmHours;
            console.log("attedence DATA CHECKKK ==>", item.attendance[i])

            if (item.attendance[i].amStatus && (item.attendance[i].amStatus == 'Unauthorized Absence')) amStatus = 'Unauthorised Absence'
            else if (item.attendance[i].amStatus && (item.attendance[i].amStatus == 'Authorized Absence')) amStatus = 'Authorised Absence'
            else amStatus = item.attendance[i].amStatus

            if (item.attendance[i].pmStatus && (item.attendance[i].pmStatus == 'Unauthorized Absence')) pmStatus = 'Unauthorised Absence'
            else if (item.attendance[i].pmStatus && (item.attendance[i].pmStatus == 'Authorized Absence')) pmStatus = 'Authorised Absence'
            else pmStatus = item.attendance[i].pmStatus

            attendanceAmHours = (item.attendance[i].attendanceAmHours) ? item.attendance[i].attendanceAmHours : "00:00"
            attendancePmHours = (item.attendance[i].attendancePmHours) ? item.attendance[i].attendancePmHours : "00:00"

            console.log("ATTEDENCE DATA==>", attendanceAmHours)

            temp["Day-" + String(i + 1) + "(AM)"] = amStatus
            temp["Day-" + String(i + 1) + "(PM)"] = pmStatus
            // temp["Day-" + String(i + 1) + "(Time)"] = attendanceAmHours
            finalJsonArray[index] = temp
            array.push(amStatus + " - " + attendanceAmHours, pmStatus + " - " + attendancePmHours)
          }
        }
        tempArray.push(['\r'], array)
      })


      let str = "";
      tempArray.forEach(row => {
        let line = "";
        let columns =
          typeof row !== "object" ? JSON.parse(row) : Object.values(row);
        columns.forEach(column => {
          console.log("====>column", column)
          if (line !== "") {
            line += ";";
          }
          if (typeof column === "object") {
            line += JSON.stringify(column);
          } else {
            line += column;
          }
        });
        str += line + "\r\n";
      });

      console.log("temp array data here ===>", tempArray)

      // let blob = new Blob(tempArray, { type: 'text/csv;charset=utf-8;' });
      // let title = jobName ? jobName + "Register" : 'Register'
      // saveAs(blob, title + ".csv");

      observer.next(tempArray);
      () => {
        observer.complete()
      }
    })
  }

}
